$(function() {
  // ハンバーガーメニュー（SP）表示
  $('.nav-toggle').on('click', function() {
    $('.nav-toggle, .nav, .back-gray').toggleClass('show');
  });

  // ハンバーガー内プルダウンメニュー表示（SP）
  $('.dropdown-school-sp, .dropdown-class-sp').on('click', function(e) {
    var n = $(e.target).next('.dropdown-child-sp');
    if (n.is(':hidden')) {
      n.slideDown(200);
      $(this)
        .parent()
        .addClass('dropdown-show');
    } else {
      n.slideUp(200);
      $(this)
        .parent()
        .removeClass('dropdown-show');
    }
  });

  // 教室にカーソルが当たった時、display:block（PCヘッダー）
  $('.dropdown-school').on({
    mouseover: function() {
      $('.school.dropdown-child-pc').addClass('active');
      $('.school.dropdown-child-pc').addClass('flex');
    },
    mouseout: function() {
      $('.school.dropdown-child-pc').removeClass('active');
      $('.school.dropdown-child-pc').removeClass('flex');
    },
  });
  $('.school.dropdown-child-pc').on({
    mouseover: function() {
      $('.school.dropdown-child-pc').addClass('active');
      $('.school.dropdown-child-pc').addClass('flex');
    },
    mouseout: function() {
      $('.school.dropdown-child-pc').removeClass('active');
      $('.school.dropdown-child-pc').removeClass('flex');
    },
  });

  // クラスにカーソルが当たった時、display:block（PCヘッダー）
  $('.dropdown-class').on({
    mouseover: function() {
      $('.class.dropdown-child-pc').addClass('active');
      $('.class.dropdown-child-pc').addClass('flex');
    },
    mouseout: function() {
      $('.class.dropdown-child-pc').removeClass('active');
      $('.class.dropdown-child-pc').removeClass('flex');
    },
  });
  $('.class.dropdown-child-pc').on({
    mouseover: function() {
      $('.class.dropdown-child-pc').addClass('active');
      $('.class.dropdown-child-pc').addClass('flex');
    },
    mouseout: function() {
      $('.class.dropdown-child-pc').removeClass('active');
      $('.class.dropdown-child-pc').removeClass('flex');
    },
  });
});
